import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {Tooltip} from '../tooltip/tooltip';
import {Icon} from '../icon/icon';

require('../../../../icons/right.svg');
require('../../../../icons/down.svg');
require('../../../../icons/questioncircleo.svg');

@Component({
  template: require('./panel.html'),
  name: 'wc-panel',
  components: {
    'wc-tooltip':Tooltip
     , 'wc-icon':Icon
  }
})
export class Panel extends Vue {
 
  @Prop()
  header: string;

  @Prop()
  tooltip: string;

  @Prop()
  tooltipPosition: string;

  @Prop()
  expand: boolean;

  active: boolean = false;

  created() {
    if (this.expand) this.active = true;
  }

  headerClick() {
    this.active = !this.active;
  }
}




// WEBPACK FOOTER //
// src/../~/wc-lib/src/wc-ui/components/collapse/panel.ts